import {
  takeEvery, all, call, put, select, takeLatest,
} from 'redux-saga/effects';

import { apiGetAllTransactions } from './api';

import {
  getMoreTransactionsActions,
  getMoreTransactionsActionTypes,
  actionTypes,
} from './actions';

import { accountChangedActionType } from '../accountService/actions';

const getNormalizedTransactions = (transactions) => {
  const normalizedTransactions = {};

  transactions.forEach((transaction) => {
    normalizedTransactions[transaction.transaction_id] = transaction;
  });

  return normalizedTransactions;
};

function* fetchTransactions() {
  try {
    yield put(getMoreTransactionsActions.request());
    const companyId = yield select((state) => state.appService.companyId);
    const accountId = yield select((state) => state.accountService.account.id);

    const { dates } = yield select((state) => state.transactionsService);

    const response = yield call(() => apiGetAllTransactions(
      companyId,
      accountId,
      0,
      dates,
    ));
    const responseJson = yield response.json();
    const transactions = getNormalizedTransactions(responseJson.data.items);
    const newTransactionsList = responseJson.data.items;
    const transactionsTotal = responseJson.data.total;
    yield put(getMoreTransactionsActions.success(
      transactions,
      newTransactionsList,
      transactionsTotal,
    ));
  } catch (error) {
    console.error(error);
    yield put(getMoreTransactionsActions.error(error));
  }
}

function* fetchMoreTransactions() {
  try {
    const loading = yield select((state) => state.transactionsService.loading);

    if (loading) {
      return;
    }

    yield put(getMoreTransactionsActions.request());

    const accountId = yield select((state) => state.accountService.account.id);
    const companyId = yield select((state) => state.appService.companyId);
    const { transactionsList, dates } = yield select((state) => state.transactionsService);

    const response = yield call(() => apiGetAllTransactions(
      companyId,
      accountId,
      transactionsList.length,
      dates,
    ));
    const responseJson = yield response.json();
    const transactions = getNormalizedTransactions(responseJson.data.items);
    const newTransactionsList = [...transactionsList];
    newTransactionsList.push(...responseJson.data.items);
    const transactionsTotal = responseJson.data.total;
    yield put(getMoreTransactionsActions.success(
      transactions,
      newTransactionsList,
      transactionsTotal,
    ));
  } catch (error) {
    console.error(error);
    yield put(getMoreTransactionsActions.error(error));
  }
}

function* onDataChanged() {
  yield call(fetchTransactions);
}

function* onAccountChanged() {
  yield call(fetchTransactions);
}

function* watchGetTransactions() {
  yield takeLatest(actionTypes.UPDATE_DATES, onDataChanged);
  yield takeEvery(getMoreTransactionsActionTypes.common, fetchMoreTransactions);
  yield takeLatest(accountChangedActionType, onAccountChanged);
}

export default function* root() {
  yield all([
    watchGetTransactions(),
  ]);
}
